export const pt = {
  nav: {
    home: "Início",
    adult: "Adulto",
    kids: "Kids",
    radar: "Radar",
    partners: "Parceiros",
    scheduleTrial: "Agendar aula experimental",
  },
  footer: {
    tagline: "Liderança não se improvisa, se treina.",
    copyright: "© 2026 Vagner Lima",
    privacy: "Política de Privacidade",
    terms: "Termos de Uso",
    dataDeletion: "Exclusão de Dados",
  },
  contactBanner: {
    kids: {
      eyebrow: "DÊ O PRIMEIRO PASSO",
      title: "A liderança começa na infância.",
      description: "Converse com o professor e descubra como o Jiu-Jitsu pode contribuir para o desenvolvimento do seu filho.",
      cta: "Agendar aula experimental do meu filho",
    },
    adult: {
      eyebrow: "VIVA A EXPERIÊNCIA",
      title: "Sua próxima decisão começa no tatame.",
      description: "Descubra uma experiência que conecta os desafios do tatame às decisões da liderança.",
      cta: "Conversar sobre aulas e experiências",
    },
  },
  home: {
    hero: {
      eyebrow: "UMA METODOLOGIA • DUAS JORNADAS",
      title: "Liderança não se improvisa, se treina.",
      subtitle: "Jiu-Jitsu, liderança e mundo corporativo unidos em uma metodologia para adultos, empresas e crianças.",
      chooseMethod: "Escolha sua metodologia",
      howToParticipate: "Como participar →",
      photoLabel: "PROFESSOR • FAIXA-PRETA",
    },
    journeys: {
      eyebrow: "ESCOLHA SEU CAMINHO",
      title: "Duas jornadas. O mesmo propósito.",
      subtitle: "Selecione a metodologia que deseja conhecer.",
      adult: {
        tag: "PARA ADULTOS, LÍDERES E EMPRESÁRIOS",
        title: "Executive Jiu-Jitsu",
        desc: "Estratégia, autocontrole e decisões sob pressão.",
        cta: "CONHECER METODOLOGIA ADULTO →",
      },
      kids: {
        tag: "PARA CRIANÇAS E SUAS FAMÍLIAS",
        title: "Executive Jiu-Jitsu Kids",
        desc: "Respeito, confiança e liderança desde a infância.",
        cta: "CONHECER METODOLOGIA KIDS →",
      },
    },
    bridge: {
      eyebrow: "JIU-JITSU + MUNDO CORPORATIVO",
      title: "O que acontece no tatame não termina no tatame.",
      p1: "Pressão, estratégia, adaptação, controle emocional e decisão fazem parte tanto do Jiu-Jitsu quanto da rotina de quem lidera pessoas e negócios.",
      p2: "O Executive Jiu-Jitsu transforma situações vividas no treino em reflexões práticas para a empresa, para a família e para a vida.",
      step1: "01 VIVER",
      step2: "02 COMPREENDER",
      step3: "03 APLICAR",
    },
    participation: {
      eyebrow: "ENCONTRE A EXPERIÊNCIA CERTA",
      title: "Como participar. Escolha o seu caminho.",
      subtitle: "Uma proposta para cada objetivo, sempre com acompanhamento do professor Vagner Lima.",
      card1: {
        tag: "01 · INDIVIDUAL",
        title: "Aulas particulares",
        desc: "Uma experiência personalizada para adultos que buscam desenvolvimento técnico, estratégia e evolução no próprio ritmo.",
        cta: "CONSULTAR DISPONIBILIDADE →",
      },
      card2: {
        tag: "02 · LIDERANÇA",
        title: "Grupos executivos",
        desc: "Vivências que conectam o Jiu-Jitsu aos desafios de líderes, empresários e profissionais em desenvolvimento.",
        cta: "CONHECER A PROPOSTA →",
      },
      card3: {
        tag: "03 · EMPRESAS",
        title: "Experiências corporativas",
        desc: "Leve para sua equipe uma reflexão prática sobre liderança, comunicação, pressão e tomada de decisão.",
        cta: "FALAR SOBRE MINHA EMPRESA →",
      },
      card4: {
        tag: "04 · INFÂNCIA",
        title: "Turmas Kids",
        desc: "Disciplina, respeito, confiança e responsabilidade em uma experiência pensada para a formação das crianças.",
        cta: "CONHECER O EXECUTIVE KIDS →",
      },
      schedule: {
        adultTitle: "ADULTO",
        adultTime: "Segunda, quarta e sexta · 19h e 21h15",
        kidsTitle: "KIDS",
        kidsTime: "Segunda, quarta e sexta · 10h e 14h",
        locationTitle: "ONDE",
        locationAddress: "CT Haseyo · Rua Francisco Jacinto de Melo, 1277",
      },
    },
    beyond: {
      eyebrow: "ALÉM DO TREINO",
      title: "O aprendizado continua fora do tatame.",
      subtitle: "A experiência se conecta com os desafios reais da liderança e da vida.",
      feature1Title: "Desafios de liderança",
      feature1Desc: "O aprendizado aplicado à rotina profissional e pessoal.",
      feature2Title: "Evolução contínua",
      feature2Desc: "Consistência, conquistas e desenvolvimento individual.",
      feature3Title: "Radar Executivo",
      feature3Desc: "Mercado, economia e negócios para quem precisa decidir.",
      cta: "Acessar o Radar Executivo →",
    },
    radarPreview: {
      eyebrow: "CONTEÚDO PARA QUEM DECIDE",
      title: "Radar Executivo. Informação com aplicação.",
      subtitle: "Uma curadoria pensada para conectar o que acontece no mercado às decisões de líderes e empresários.",
      card1Tag: "ECONOMIA",
      card1Title: "Cenário econômico",
      card1Desc: "Movimentos que influenciam custos, demanda, crédito e planejamento.",
      card2Tag: "FINANÇAS",
      card2Title: "Decisões financeiras",
      card2Desc: "Informação relevante para caixa, investimentos e gestão de riscos.",
      card3Tag: "LIDERANÇA",
      card3Title: "Visão Executive",
      card3Desc: "A leitura prática: como isso afeta sua empresa e suas decisões?",
      cta: "Explorar o Radar Executivo →",
    },
    partnersPreview: {
      eyebrow: "CONEXÕES QUE GERAM OPORTUNIDADES",
      title: "Parcerias estratégicas. Negócios também se constroem juntos.",
      subtitle: "Empresas e profissionais conectados ao universo da liderança, das finanças e do desenvolvimento pessoal.",
      cta: "Conhecer empresas parceiras",
      cardTag: "PARCEIRO EXECUTIVE · CONSÓRCIOS",
      cardDesc: "Planejamento para aquisição de imóveis, veículos e construção patrimonial.",
      cardCta: "CONHECER PARCERIA →",
    },
    professor: {
      eyebrow: "QUEM CONDUZ A EXPERIÊNCIA",
      name: "Vagner Lima",
      subtitle: "Do mercado financeiro ao tatame.",
      desc: "Professor faixa-preta de Jiu-Jitsu e profissional com mais de 14 anos de experiência no mercado financeiro, Vagner une estratégia, desenvolvimento humano e vivência prática em uma metodologia própria.",
      badge1Num: "14+",
      badge1Text: "ANOS NO MERCADO FINANCEIRO",
      badge2Num: "FAIXA-PRETA",
      badge2Text: "PROFESSOR DE JIU-JITSU",
      quote: "“O tatame transforma princípios em experiências para a vida.”",
      cta: "Conversar com o professor",
    },
  },
  adult: {
    hero: {
      eyebrow: "METODOLOGIA ADULTO",
      title: "O tatame ensina. A liderança transforma.",
      subtitle: "Uma experiência que conecta os princípios do Jiu-Jitsu aos desafios reais de quem lidera, empreende e decide sob pressão.",
      cta: "Conheça a proposta",
    },
    editorial: {
      eyebrow: "EXECUTIVE JIU-JITSU",
      title: "Não é sobre formar lutadores. É sobre treinar líderes.",
      p1: "No ambiente corporativo, decisões importantes raramente chegam em condições perfeitas. Há pressão, incerteza, risco e pouco tempo.",
      p2: "No tatame, o aluno vivencia situações que estimulam controle emocional, leitura de cenário, adaptação e tomada de decisão — competências que ultrapassam o treino.",
      step1Title: "Experiência",
      step1Desc: "O princípio é vivenciado em uma situação real de treino.",
      step2Title: "Reflexão",
      step2Desc: "O aluno reconhece sua reação, suas escolhas e os resultados.",
      step3Title: "Aplicação",
      step3Desc: "O aprendizado é conectado aos desafios da liderança e dos negócios.",
    },
    corporatePhoto: {
      eyebrow: "DO CORPORATIVO PARA O TATAME",
      title: "Experiência de mercado. Vivência real no Jiu-Jitsu.",
      p1: "O Executive Jiu-Jitsu nasce da união entre dois ambientes que exigem preparo: o mundo dos negócios e o tatame.",
      p2: "Metas, negociação, risco, pressão e relacionamento encontram disciplina, estratégia, adaptação e controle emocional.",
      quote: "“Não é sobre transformar executivos em lutadores. É sobre treinar líderes.”",
    },
    principles: {
      eyebrow: "A ESSÊNCIA DA METODOLOGIA",
      title: "10 princípios. Uma liderança mais preparada.",
      viewMore: "CONHECER OS OUTROS CINCO PRINCÍPIOS",
      items: [
        { num: "01", title: "Estabilidade", desc: "Construir uma base sólida para decidir com segurança." },
        { num: "02", title: "Adaptação", desc: "Encontrar possibilidades mesmo em cenários desfavoráveis." },
        { num: "03", title: "Conexão", desc: "Fortalecer relações, escuta e influência positiva." },
        { num: "04", title: "Estratégia", desc: "Transformar movimento em avanço com clareza e método." },
        { num: "05", title: "Controle", desc: "Consolidar antes de acelerar e agir com consciência." },
        { num: "06", title: "Sustentação", desc: "Manter resultados através de consistência e equilíbrio." },
        { num: "07", title: "Reação", desc: "Responder a desafios com inteligência e resiliência." },
        { num: "08", title: "Pressão", desc: "Conduzir situações difíceis com propósito e autocontrole." },
        { num: "09", title: "Oportunidade", desc: "Reconhecer os caminhos criados pela preparação." },
        { num: "10", title: "Execução", desc: "Transformar boas decisões em resultados concretos." },
      ],
    },
    benefits: {
      eyebrow: "PARA QUEM É",
      title: "Para quem lidera pessoas, negócios e decisões.",
      audiences: [
        "Empresários e empreendedores",
        "Executivos e gestores",
        "Profissionais em desenvolvimento",
        "Adultos que buscam evolução pessoal",
      ],
    },
    formats: {
      eyebrow: "COMO PARTICIPAR",
      title: "Uma experiência. Diferentes possibilidades.",
      card1Title: "Aulas particulares",
      card1Desc: "Atendimento individual e desenvolvimento no seu ritmo.",
      card2Title: "Grupos executivos",
      card2Desc: "Jiu-Jitsu e liderança para profissionais e empresários.",
      card3Title: "Experiências corporativas",
      card3Desc: "Uma proposta para equipes, empresas e desenvolvimento de líderes.",
      cta: "Encontrar a melhor experiência para mim",
    },
    ecosystem: {
      eyebrow: "UM ECOSSISTEMA DE DESENVOLVIMENTO",
      title: "Treinar. Refletir. Evoluir continuamente.",
      subtitle: "A proposta conecta a experiência presencial a desafios de liderança, acompanhamento de evolução e conteúdo de mercado.",
      card1Title: "Tatame",
      card1Desc: "Experiência prática, pressão controlada e tomada de decisão.",
      card2Title: "Desafios",
      card2Desc: "O aprendizado levado para situações reais da rotina.",
      card3Title: "Evolução",
      card3Desc: "Registro objetivo de frequência, horas, técnicas e conquistas.",
      card4Title: "Radar",
      card4Desc: "Economia, finanças, negócios e liderança com contexto.",
    },
  },
  kids: {
    hero: {
      eyebrow: "EXECUTIVE JIU-JITSU KIDS",
      title: "Líderes no Tatame.",
      subtitle: "Mais do que aprender movimentos: desenvolver confiança, valores e atitudes que acompanham a criança dentro e fora do tatame.",
      cta: "Conheça a metodologia",
      badge: "FORMANDO LÍDERES DESDE A INFÂNCIA",
    },
    editorial: {
      eyebrow: "O QUE SEU FILHO VAI DESENVOLVER",
      title: "A confiança começa no tatame. E acompanha a criança pela vida.",
      p1: "A metodologia Líderes no Tatame utiliza o Jiu-Jitsu como ferramenta de desenvolvimento físico, emocional e social, respeitando a idade e o ritmo de cada criança.",
      p2: "Por meio de experiências apropriadas à infância, trabalhamos atitudes que podem ser percebidas em casa, na escola e na convivência com outras pessoas.",
    },
    pillars: {
      eyebrow: "CINCO PILARES DE FORMAÇÃO",
      title: "Pequenos no tamanho. Grandes na atitude.",
      items: [
        { num: "01", title: "Respeito", desc: "Aprender a ouvir, esperar a vez e tratar as pessoas com cuidado." },
        { num: "02", title: "Autocontrole", desc: "Reconhecer emoções, controlar a força e pensar antes de agir." },
        { num: "03", title: "Coragem", desc: "Enfrentar novos desafios e continuar tentando diante das dificuldades." },
        { num: "04", title: "Cooperação", desc: "Ajudar, compartilhar conquistas e compreender o valor do grupo." },
        { num: "05", title: "Responsabilidade", desc: "Cuidar das próprias atitudes, do espaço e das pessoas ao redor." },
      ],
      promiseTitle: "Cada criança evolui no seu próprio ritmo.",
      promiseSubtitle: "Sem rankings públicos, rótulos ou comparações.",
    },
    family: {
      eyebrow: "O QUE OS PAIS PODEM ESPERAR",
      title: "Uma formação que vai além da técnica.",
      benefit1Title: "Mais confiança",
      benefit1Desc: "A criança aprende a reconhecer suas conquistas e enfrentar desafios com segurança.",
      benefit2Title: "Mais equilíbrio emocional",
      benefit2Desc: "Desenvolve a capacidade de compreender sentimentos e responder com mais consciência.",
      benefit3Title: "Mais convivência",
      benefit3Desc: "Fortalece respeito, cooperação e atitudes positivas dentro e fora do ambiente de treino.",
      benefit4Title: "Família presente",
      benefit4Desc: "Os aprendizados conversam com a rotina da casa e acompanham a evolução individual.",
    },
    schedule: {
      eyebrow: "HORÁRIOS E LOCAL",
      title: "A primeira conquista começa com o primeiro passo.",
      whenTitle: "QUANDO",
      whenDesc: "Segunda, quarta e sexta-feira",
      whenHours: "10h e 14h",
      whereTitle: "ONDE",
      wherePlace: "CT Haseyo",
      whereAddress: "Rua Francisco Jacinto de Melo, 1277",
    },
  },
  radar: {
    hero: {
      eyebrow: "RADAR EXECUTIVO",
      title: "Notícias para quem precisa decidir.",
      subtitle: "Mercado financeiro, liderança, empresas, economia e negócios reunidos em um só lugar — sempre com contexto para o mundo corporativo.",
      liveNews: "NOTÍCIAS ATUALIZADAS AUTOMATICAMENTE",
      editorialSources: "CURADORIA DE FONTES PARA O MUNDO CORPORATIVO",
    },
    orbit: {
      mercado: "MERCADO",
      financas: "FINANÇAS",
      empresas: "EMPRESAS",
      lideranca: "LIDERANÇA",
      negocios: "NEGÓCIOS",
    },
    newsArea: {
      eyebrow: "ACONTECE AGORA",
      title: "O mundo em movimento. Sua estratégia também.",
      liveSubtitle: "Notícias recentes reunidas de diferentes veículos, com contexto para quem lidera.",
      editorialSubtitle: "Acesse diretamente editorias confiáveis e acompanhe os assuntos que influenciam decisões de liderança.",
      lastUpdate: "Última atualização:",
      recentUpdate: "Atualização recente",
      selectedSources: "FONTES SELECIONADAS",
      newsCount: "{{count}} NOTÍCIAS",
      sourcePrefix: "Fonte:",
      executiveView: "VISÃO EXECUTIVE",
      readFull: "LER NOTÍCIA ↗",
      accessEditorial: "ACESSAR EDITORIA ↗",
    },
    method: {
      eyebrow: "MAIS DO QUE INFORMAÇÃO",
      title: "Leia o cenário. Prepare a decisão.",
      step1Title: "Fato",
      step1Desc: "Entenda objetivamente o que aconteceu.",
      step2Title: "Contexto",
      step2Desc: "Reconheça riscos, impactos e oportunidades.",
      step3Title: "Decisão",
      step3Desc: "Conecte a notícia à realidade da sua empresa e da sua liderança.",
    },
    cta: {
      eyebrow: "JIU-JITSU + MUNDO CORPORATIVO",
      title: "Consciência antes da ação. Estratégia antes da força.",
      button: "Conhecer a metodologia Adulto",
    },
  },
  partners: {
    hero: {
      eyebrow: "REDE EXECUTIVE JIU-JITSU",
      title: "Conexões certas. Oportunidades reais.",
      subtitle: "Uma rede de empresas e profissionais que compartilham valores como confiança, estratégia e crescimento.",
      cta: "Conhecer nossos parceiros",
      markTag: "EXECUTIVE",
      markTitle: "Conexões & negócios.",
      markSubtitle: "DO TATAME AO MUNDO CORPORATIVO",
    },
    intro: {
      eyebrow: "PARCERIAS ESTRATÉGICAS",
      title: "Mais do que indicações. Relações construídas com confiança.",
      desc: "O Executive Jiu-Jitsu conecta empresários, executivos, famílias e profissionais a empresas que podem contribuir com objetivos pessoais, patrimoniais e corporativos.",
    },
    showcase: {
      eyebrow: "PARCEIROS EXECUTIVE",
      title: "Empresas que fazem parte da nossa rede.",
      partnerTag: "PARCEIRO EXECUTIVE",
      category: "CONSÓRCIOS · PLANEJAMENTO PATRIMONIAL",
      cardTitle: "Planejar hoje. Conquistar com estratégia.",
      cardDesc: "Soluções em consórcios para quem busca planejar a aquisição de imóveis, veículos e outros objetivos patrimoniais.",
      tag1: "Imóveis",
      tag2: "Veículos",
      tag3: "Planejamento",
      cta: "Solicitar indicação do parceiro",
      disclosure: "As empresas apresentadas são responsáveis pelas informações, condições e serviços oferecidos. Entre em contato para conhecer cada proposta.",
    },
    connectionAreas: {
      eyebrow: "UMA REDE EM EXPANSÃO",
      title: "Áreas que se conectam ao seu universo.",
      items: [
        { num: "01", title: "Consórcios e patrimônio", desc: "Soluções para planejamento, aquisição de bens e construção patrimonial." },
        { num: "02", title: "Finanças e negócios", desc: "Crédito, organização financeira e oportunidades para empresas e profissionais." },
        { num: "03", title: "Assessoria empresarial", desc: "Apoio jurídico, contábil e estratégico para decisões mais seguras." },
        { num: "04", title: "Saúde e performance", desc: "Profissionais conectados ao bem-estar, à qualidade de vida e ao desempenho." },
      ],
    },
    invitation: {
      eyebrow: "SUA EMPRESA E O EXECUTIVE JIU-JITSU",
      title: "Boas conexões abrem novos caminhos.",
      desc: "Se a sua empresa compartilha valores como confiança, excelência e desenvolvimento, vamos conversar sobre uma parceria.",
      cta: "Quero apresentar minha empresa",
    },
  },
  legal: {
    badge: "CONFORMIDADE & TRANSPARÊNCIA",
    lastUpdated: "Última atualização: 28 de agosto de 2026",
    tabs: {
      privacy: "Política de Privacidade",
      terms: "Termos de Uso",
      dataDeletion: "Exclusão de Dados",
    },
    privacy: {
      title: "Política de Privacidade",
      subtitle: "Compromisso com a segurança, privacidade e proteção dos seus dados pessoais em conformidade com a LGPD (Lei nº 13.709/2018), Google Play Console e Apple App Store.",
      sections: [
        {
          title: "1. Identificação do Controlador",
          content: "O Executive Jiu-Jitsu, sob a liderança e responsabilidade técnica do Professor Vagner Lima, atua como controlador dos seus dados pessoais coletados por meio de nossos aplicativos móveis (Google Play e Apple App Store), plataformas digitais e canais de atendimento oficial.",
        },
        {
          title: "2. Dados Pessoais Coletados",
          content: "Coletamos apenas as informações estritamente necessárias para a prestação dos nossos serviços de treinamento, agendamento de aulas e gestão acadêmica:\n• Dados de identificação e contato: Nome completo, endereço de e-mail, número de telefone (WhatsApp) e data de nascimento.\n• Dados de perfil e participação: Graduação (faixa), histórico de presença, turmas matriculadas (Adulto/Kids) e agendamentos de aulas experimentais.\n• Dados técnicos de uso: Identificadores anônimos de dispositivo, versão do sistema operacional e relatórios técnicos essenciais para a estabilidade do aplicativo.",
        },
        {
          title: "3. Finalidade e Base Legal do Tratamento",
          content: "Seus dados são tratados com respaldo nas bases legais da LGPD (Art. 7º, incisos I e V):\n• Gestão de agendamentos de aulas, check-in e controle de presença.\n• Comunicação direta sobre avisos de treinos, eventos, graduações e avisos institucionais.\n• Suporte ao usuário e aprimoramento contínuo da experiência no aplicativo.\n• Cumprimento de obrigações legais, regulatórias ou fiscais aplicáveis.",
        },
        {
          title: "4. Compartilhamento Seguro de Dados",
          content: "O Executive Jiu-Jitsu não vende, não aluga e não comercializa seus dados pessoais com terceiros para fins publicitários. O compartilhamento ocorre exclusivamente com prestadores de infraestrutura tecnológica indispensáveis (hospedagem em nuvem com criptografia, bancos de dados seguros e notificações push), todos vinculados a rigorosos deveres de confidencialidade.",
        },
        {
          title: "5. Segurança e Armazenamento da Informação",
          content: "Adotamos padrões elevados de segurança, incluindo tráfego de dados protegido por criptografia TLS/HTTPS, controles de acesso restrito e monitoramento contínuo para evitar incidentes, vazamentos ou acessos não autorizados.",
        },
        {
          title: "6. Direitos do Titular (LGPD e Regulamentações Internacionais)",
          content: "Você possui o direito garantido de solicitar a qualquer momento:\n• Confirmação da existência de tratamento e acesso aos seus dados.\n• Correção de dados incompletos, inexatos ou desatualizados.\n• Revogação do consentimento concedido anteriormente.\n• Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade.\n• Exclusão definitiva de sua conta e dados pessoais.",
        },
        {
          title: "7. Contato do Encarregado de Dados (DPO)",
          content: "Para qualquer dúvida, esclarecimento ou requisição relacionada aos seus dados pessoais, entre em contato diretamente com nossa equipe de privacidade através do e-mail: contato@executivejiujitsu.com ou pelo WhatsApp oficial (48) 99608-7396.",
        },
      ],
    },
    terms: {
      title: "Termos de Uso",
      subtitle: "Condições gerais de navegação, utilização do aplicativo móvel, agendamentos e participação nas atividades do Executive Jiu-Jitsu.",
      sections: [
        {
          title: "1. Aceitação dos Termos",
          content: "Ao baixar, instalar ou utilizar o aplicativo móvel e as plataformas digitais do Executive Jiu-Jitsu, você declara ter lido, compreendido e concordado integralmente com estes Termos de Uso e com nossa Política de Privacidade.",
        },
        {
          title: "2. Cadastro e Uso da Conta",
          content: "O usuário se compromete a fornecer dados verídicos e atualizados durante seu cadastro ou agendamento. É de inteira responsabilidade do usuário a preservação do sigilo de suas credenciais de acesso, não devendo compartilhá-las com terceiros.",
        },
        {
          title: "3. Prática Esportiva e Aptidão Física",
          content: "O Jiu-Jitsu é uma arte marcial de contato que exige esforço físico. O usuário (ou seu responsável legal, no caso do Executive Kids) declara estar em plenas condições de saúde e aptidão física para a prática das atividades propostas, recomendando-se a realização prévia de avaliação médica periódica.",
        },
        {
          title: "4. Conduta e Filosofia no Tatame",
          content: "Prezamos pelo respeito mútuo, segurança, disciplina e integridade de todos os praticantes. Comportamentos discriminatórios, antidesportivos, imprudentes ou agressivos que violem os princípios da arte marcial resultarão na suspensão imediata do acesso aos treinos e ao aplicativo.",
        },
        {
          title: "5. Propriedade Intelectual",
          content: "Todas as marcas, metodologias, logotipos, conteúdos de treinamento, textos, fotos, vídeos e códigos associados ao Executive Jiu-Jitsu e ao Professor Vagner Lima são de propriedade exclusiva e estão protegidos pelas leis de direitos autorais e propriedade industrial.",
        },
        {
          title: "6. Cancelamento e Modificações dos Termos",
          content: "O Executive Jiu-Jitsu reserva-se o direito de atualizar periodicamente estes termos para refletir melhorias no serviço ou exigências legais. O usuário pode cancelar seu cadastro a qualquer momento, solicitando a exclusão de sua conta.",
        },
        {
          title: "7. Legislação Aplicável e Foro",
          content: "Estes termos são regidos pelas leis da República Federativa do Brasil. Para a resolução de eventuais litígios decorrentes deste instrumento, fica eleito o Foro da Comarca de Palhoça / Florianópolis, Estado de Santa Catarina.",
        },
      ],
    },
    dataDeletion: {
      title: "Exclusão de Conta e Dados Pessoais",
      subtitle: "Instruções claras e transparentes para a solicitação de eliminação definitiva de conta e dados pessoais, em total conformidade com as diretrizes do Google Play e Apple Store.",
      overview: "O Executive Jiu-Jitsu respeita a sua privacidade e a sua autonomia sobre os seus dados. Se você é aluno, responsável ou usuário de nosso aplicativo e deseja excluir sua conta e informações pessoais de nossa base de dados, disponibilizamos canais diretos e acessíveis para que o procedimento seja realizado sem complicações.",
      howToTitle: "Como solicitar a exclusão da sua conta:",
      steps: [
        {
          num: "01",
          title: "Preencha o formulário abaixo",
          desc: "Informe seu nome completo e o e-mail cadastrado no aplicativo ou nos agendamentos.",
        },
        {
          num: "02",
          title: "Envio automático e seguro",
          desc: "Você pode enviar a requisição diretamente pela página, via e-mail formal pré-formatado ou via WhatsApp oficial.",
        },
        {
          num: "03",
          title: "Confirmação e Processamento",
          desc: "Nossa equipe confirmará o recebimento e efetuará a remoção dos seus dados no prazo máximo legal de até 15 (quinze) dias úteis.",
        },
      ],
      tableTitle: "Detalhamento de retenção e exclusão de dados:",
      tableHeaders: {
        category: "Tipo de Dado",
        action: "Ação de Exclusão",
        retention: "Retenção / Justificativa Legal",
      },
      tableRows: [
        {
          category: "Conta e Acesso (login, senha, e-mail)",
          action: "Excluídos permanentemente",
          retention: "Eliminação imediata após confirmação da solicitação.",
        },
        {
          category: "Dados de Perfil (nome, telefone, faixa, foto)",
          action: "Excluídos permanentemente",
          retention: "Eliminados de forma irreversível de nossos servidores ativos.",
        },
        {
          category: "Histórico de Presenças e Aulas Agendadas",
          action: "Anonimizados / Excluídos",
          retention: "Registros históricos desvinculados de qualquer identificador pessoal.",
        },
        {
          category: "Registros Fiscais e Comprovantes de Pagamento",
          action: "Retidos pelo prazo legal",
          retention: "Mantidos estritamente pelo período exigido pela legislação tributária brasileira (5 anos), em acesso restrito e seguro.",
        },
      ],
      form: {
        title: "Formulário de Solicitação de Exclusão",
        desc: "Preencha os campos abaixo para solicitar formalmente a exclusão da sua conta e de todos os seus dados pessoais associados.",
        nameLabel: "Nome completo",
        namePlaceholder: "Digite seu nome completo",
        emailLabel: "E-mail cadastrado no aplicativo",
        emailPlaceholder: "exemplo@email.com",
        reasonLabel: "Motivo da exclusão (opcional)",
        reasonPlaceholder: "Conte-nos se houve algum problema ou se apenas deseja encerrar o cadastro...",
        consentLabel: "Estou ciente de que a exclusão da minha conta é definitiva e removerá meu histórico de treinos e graduações.",
        submitEmailBtn: "Solicitar exclusão por E-mail",
        submitWhatsappBtn: "Solicitar exclusão por WhatsApp",
        validationError: "Por favor, preencha seu nome, e-mail válido e confirme a ciência dos termos.",
        successMsg: "Sua solicitação foi preparada com sucesso! Se a janela de e-mail não abriu automaticamente, você também pode nos contatar pelo WhatsApp clicando no botão abaixo.",
      },
    },
  },
};

